// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sl-9";
export var arrowButtonContainer = "_sl-5";
export var arrowButtonIcon = "_sl-6";
export var carouselArrowButton = "_sl-2";
export var carouselElementContainer = "_sl-1";
export var currentSlide = "_sl-8";
export var left = "_sl-3";
export var otherSlide = "_sl-a";
export var productCarouselContainer = "_sl-0";
export var right = "_sl-4";
export var sliderOverflow = "_sl-7";